/* eslint-disable import/no-anonymous-default-export */
import { Descriptions } from "antd";
import styled from "styled-components";

const ContainerKeyboardInfo = styled.div`
margin-top: 0.5rem;
`;

export default () => {

    return (<ContainerKeyboardInfo>
        <Descriptions labelStyle={{ color: 'var(--primary-color)' }} size="small" layout="vertical" style={{ 'fontSize': 10 }} bordered={true} title="Colores de verificación">
            <Descriptions.Item labelStyle={{ 'fontWeight': 'bold',color: '#3f9c46' }} label="Verde">El lote esta verificado completamente</Descriptions.Item>
            <Descriptions.Item labelStyle={{ 'fontWeight': 'bold',color: '#0288d1' }} label="Azul">Todas las infracciones del lote están pendientes de verificación</Descriptions.Item>
            <Descriptions.Item labelStyle={{ 'fontWeight': 'bold', color: '#efff41d3' }} label="Amarillo">El lote se empezó a verificar pero está incompleto</Descriptions.Item>
            <Descriptions.Item labelStyle={{ 'fontWeight': 'bold', color: '#ee701b' }} label="Naranja">El lote tiene infracciones pendientes de consulta</Descriptions.Item>
            <Descriptions.Item labelStyle={{ 'fontWeight': 'bold', color: '#ff5252' }} label="Rojo">El lote tiene todas las infracciones pendientes de consulta</Descriptions.Item>
        </Descriptions>
    </ContainerKeyboardInfo>);
}